import React from "react";
import { Link } from "react-router-dom";
import { Toaster } from "sonner";
import { ArrowLeft } from "lucide-react";
import { BrandMark } from "@/components/BrandMark";
import FeedbackForm from "@/components/FeedbackForm";
import LandingBottomNav from "@/components/LandingBottomNav";

/**
 * Dedicated /feedback route — hosts the FeedbackForm that used to sit at
 * the bottom of the Landing page. Accessed via the "Feedback" link in the
 * landing footer.
 */
export default function FeedbackPage() {
  return (
    <div
      className="cartiq-wellness min-h-screen bg-[#F8FAFC] text-[#334155] relative pb-20 md:pb-0"
      data-testid="feedback-page"
    >
      <Toaster position="top-center" richColors theme="light" />

      <header className="border-b border-[#2A2A35] bg-[#0A0A0F]/80 backdrop-blur sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-3 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-2">
          <BrandMark />
          <Link
            to="/"
            className="text-[10px] sm:text-xs uppercase tracking-[0.14em] sm:tracking-[0.18em] font-bold px-2 sm:px-3 py-1.5 sm:py-2 border border-[#2A2A35] text-[#888] hover:text-[#F0EDE8] hover:border-[#F0EDE8] transition-colors whitespace-nowrap inline-flex items-center gap-1.5"
            data-testid="feedback-back-link"
          >
            <ArrowLeft className="w-3 h-3" />
            <span className="hidden sm:inline">Back to home</span>
            <span className="sm:hidden">Back</span>
          </Link>
        </div>
      </header>

      <section className="max-w-4xl mx-auto px-6 pt-10 md:pt-14 pb-6 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 border border-[#FF6B00] text-[#FF6B00] text-[11px] uppercase tracking-[0.22em] font-bold">
          Feedback
        </div>
        <h1
          className="font-display uppercase mt-5 text-[clamp(32px,5vw,52px)] leading-[1.05] tracking-tight"
          data-testid="feedback-page-heading"
        >
          Tell us what&rsquo;s <span className="text-[#FF6B00]">missing.</span>
        </h1>
        <p className="mt-3 text-sm md:text-base text-[#888] max-w-xl mx-auto">
          Bug, missing app, feature idea, or just a sharp opinion — we read every one.
        </p>
      </section>

      <FeedbackForm />

      <LandingBottomNav />
    </div>
  );
}
